import React from 'react';
import { useFeatureGate } from '@atlassian/feature-gates-react';
import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { AppRouterProvider } from '../providers/AppRouterProvider';
import { createAppRouter } from './App';
import { getIdPathPrefix } from '../utilities/env';

export const FeatureGatedAppRouter = () => {
  const use2StepStateEndpoint = useFeatureGate(AidFrontendFeatureGate.USE_2STEP_STATE_ENDPOINT);
  const pbrEnabled = useFeatureGate(
    AidFrontendFeatureGate.PBR_ENABLED_API_ENDPOINT_PATH_CALCULATION
  );
  const router = React.useMemo(
    () =>
      createAppRouter({
        use2StepStateEndpoint,
        basename: pbrEnabled ? getIdPathPrefix(window.location.pathname) || '/' : '/',
      }),
    [use2StepStateEndpoint, pbrEnabled]
  );

  React.useEffect(() => () => router.dispose(), [router]);

  return <AppRouterProvider router={router} />;
};
